import React, { useContext } from 'react';
import Context from "../context/context";
import NavItem from './NavItem';
import Search from './Search';
import HiddenSearch from './HiddenSearch';


const FilterNav = props => {
  const {clearAllFilters} = props;
  const {language, filterNav} = useContext(Context);
  return (
    <>
      <div className="filter-top">
        <div className="filters-label">
        {language.filter_by}

        </div>

      </div>
      <div className="filter-nav">
      {filterNav.map((widget, i) => {

        if (typeof widget.filters != "undefined" ) {
          return <NavItem
                    key={i}
                    widget={widget}
                 />
        }
      })}
      </div>
      <div className="filter-bottom">
      {filterNav.map((widget, i) => {
        if (typeof widget.filters != "undefined" ) {


          if (widget.filters[0].type == "search") {
            return <Search key={i} data={widget.filters[0]}/>
          }
          else if (widget.filters[0].type == "hidden") {
            return <HiddenSearch key={i} data={widget.filters[0]} clearAllFilters={clearAllFilters}/>
          }
        }


      })}



      <button className="button  clear-all-filters" onClick={clearAllFilters}>
        {language.clear_all_filters}

      </button>
      </div>



    </>
  )
}

export default FilterNav;
